import {
  ProjectTaskFragment,
  UpdateProjectTaskMutationVariables,
} from 'generated/resources/graphql'

import { defaultStatus } from 'modules/tasks/lib/status'

export const projectTaskToFormData = (
  projectId: string,
  projectTask: ProjectTaskFragment
): UpdateProjectTaskMutationVariables => {
  return {
    id: projectTask.id,
    assigneeEmployeeIds: projectTask.task?.assignees
      .map(({ employee }) => employee?.id)
      .filter((id): id is string => id !== undefined),
    content: projectTask.task?.content ?? '',
    dueOn: projectTask.task?.dueOn,
    filesToAdd: [],
    filesToRemove: [],
    followUp: projectTask.followUp ?? false,
    name: projectTask.task?.name ?? '',
    position: projectTask.position,
    projectId: projectId,
    startsOn: projectTask.task?.startsOn,
    status: projectTask.task?.status ?? defaultStatus().status,
    subprojectId: projectTask.subproject?.id,
  }
}
